import { useAuth } from '@/contexts/AuthContext';
import { hasPermission, type Permission } from '@/lib/permissions';

export function usePermission() {
  const { user } = useAuth();
  return {
    can: (permission: Permission) => hasPermission(user?.role, permission),
    role: user?.role ?? null,
  };
}
